// api/auth-helper.js
import { getMSALInstance } from './msal-instance';

// This function will fetch the existing token from cache
// and check if it is valid and return the same (if valid).
// In case token is expired or close to expiry, it (acquireTokenSilent method)
// will silently make an api call to OAuth provider for new access token in exchange of existing refresh token.
// If there is not already existing token/refresh token it will throw error, that essentially make our 'tokenResponse'
// variable null in the catch block. A null value returned for tokenResponse will prevent any further call to BE .
export const checkIfExistingTokenIsValidAndFetchNewIfExpired = async (
  geoKey,
) => {
  let tokenResponse = null;
  const resourceId = window.TIEOUT.ENV.GEOS[geoKey].AD_AUD;
  const scopes = [resourceId + '/.default'];
  try {
    // This code will try to parse the token containing in cache/session.
    // It will return the token in cache if it is valid else will make an api
    // request to get new token from Oauth provider flow
    const msalInstance = getMSALInstance();
    tokenResponse = await msalInstance.acquireTokenSilent({
      account: msalInstance.getAllAccounts()[0],
      scopes: scopes,
    });
  } catch (err) {
    console.debug(err);
    tokenResponse = null;
  }

  // it will return null if existing token is null
  return tokenResponse && tokenResponse.accessToken;
};

export const handleLoginResponse = async (geoKey, isLogoutAPI = false) => {
  const msalInstance = getMSALInstance();
  let tokenResponse = await msalInstance.handleRedirectPromise();
  let accountObj;

  if (tokenResponse) {
    accountObj = tokenResponse.account;
  } else {
    accountObj = msalInstance.getAllAccounts()[0];
  }

  if (accountObj && tokenResponse) {
    const resourceId = window.TIEOUT.ENV.GEOS[geoKey].AD_AUD;
    const scopes = [resourceId + '/.default'];
    try {
      tokenResponse = await msalInstance.acquireTokenSilent({
        account: msalInstance.getAllAccounts()[0],
        scopes: scopes,
      });
    } catch (err) {
      await msalInstance.acquireTokenRedirect({ scopes: scopes });
    }
  } else {
    await msalInstance.loginRedirect();
  }

  return tokenResponse;
};

export const handleLogoutResponse = async (geoKey) => {
  let tokenResponse;
  const resourceId = window.TIEOUT.ENV.GEOS[geoKey].AD_AUD;
  const scopes = [resourceId + '/.default'];
  const msalInstance = getMSALInstance();
  try {
    tokenResponse = await msalInstance.acquireTokenSilent({
      account: msalInstance.getAllAccounts()[0],
      scopes: scopes,
    });
  } catch (err) {
    await msalInstance.acquireTokenRedirect({ scopes: scopes });
  }
  return tokenResponse;
};
